import axios from '../http'

/**
 * 获取当前用户信息
 * @returns {never}
 */
export const getUserInfo = () => {
  return axios.request({
    url: '617fe15a973d2',
    method: 'post'
  })
}
